import AuthService from '@/services/auth-service'

const getters = {
	isLoggedIn: state => state.isLoggedIn,
	loginError: state => state.loginFailed,
	loginPending: state => state.pending,
	lastError: state => state.lastError,
	me: state => state.me
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js